import { Popover, PopoverContent, PopoverTrigger } from "@nextui-org/react";

Popover.PopoverTrigger = PopoverTrigger;
Popover.PopoverContent = PopoverContent;
export default Popover;
